import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { get, post } from "../api/client";
import { useLoad } from "../api/hooks";
import type { Plans } from "../api/types";
import { fmtMoney } from "../lib/format";
import { ErrorLine, Sheet } from "./ui";

/**
 * 08 · Paid gate: the sheet (phone) / dialog (desktop) over the page that asked
 * for a player on Free (a player's picture on the match page, a tile on Choose
 * players); the one thing and the price. `onKeep` is "Keep the whole match".
 */
export function Gate({ onClose, onKeep }: { onClose: () => void; onKeep: () => void }) {
  const nav = useNavigate();
  const plans = useLoad(() => get<Plans>("/v1/billing/plans"), []);
  const basic = plans.data?.plans.find((p) => p.code === "basic");
  const price = basic?.price ? fmtMoney(basic.price.amount_minor, basic.price.currency) : "";
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<Error | null>(null);
  useEffect(() => setErr(null), []);
  const start = async () => {
    setBusy(true);
    try {
      const r = await post<{ checkout_url: string }>("/v1/billing/checkout", { plan_code: "basic" });
      window.location.assign(r.checkout_url);
    } catch (e) {
      setErr(e as Error);
      setBusy(false);
    }
  };
  return (
    <Sheet onClose={onClose}>
      <div data-testid="gate">
        <h2>Pick a player on Basic.</h2>
        <p className="sub mt10">Every ball of one batsman or bowler, as clips. {price ? `${price} a month, ` : ""}{basic ? `${basic.entitlements.videos_per_month} matches, clips kept ${basic.entitlements.retention_days} days.` : ""}</p>
        <div className="mt24"><button className="btn dark full" onClick={start} disabled={busy} data-testid="gate-start">Start Basic</button></div>
        <div className="mt10"><button className="btn ghost full" onClick={onKeep}>Keep the whole match</button></div>
        <p className="tiny center mt10">{plans.data?.region === "IN" ? "UPI Autopay or card" : "Card"} · cancel any time · <button className="u" onClick={() => nav("/plans")}>all plans</button></p>
        <ErrorLine error={err} />
      </div>
    </Sheet>
  );
}
